import React from 'react';
import classnames from 'classnames';

import s from './Spinner.module.scss';

const c = classnames.bind(s);

type Props = {
  centered?: boolean;
  text?: string;
};
const Spinner = ({ centered, text }: Props) => {
  return (
    <div className={c(s.spinner, { [s.centered]: centered })}>
      {text && <p className={s.spinner__text}>{text}</p>}
      <div className={c(s.spinner__icon)}>
        <svg className={s.spinner__svg}>
          <circle cx="20" cy="20" r="18" />
        </svg>
      </div>
    </div>
  );
};

export default Spinner;
